import { AxiosInstance } from "axios"
import { ImportResultData } from "../../../../../core/api/apiTypes"
import { createImportCsvFormData } from "../../../../../shared/components/importCsv/helpers"
import { ImportCsvFile } from "../../../../../shared/components/importCsv/importCsvFileTypes"

type ImportBillReceiversParams = Readonly<{
    companyId: number
    importData: ImportCsvFile
}>

export async function importBillReceivers(
    { companyId, importData }: ImportBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ImportResultData> {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        signal,
    }

    const { data } = await axios.post(
        `/companies/${companyId}/accounting/billReceivers/import`,
        createImportCsvFormData(importData),
        config,
    )

    return data
}
